<template>
  <div class="login">
    <ValidationObserver class="login-form" tag="div" ref="form">
      <form @submit.prevent="onSubmit" class="form">
        <ValidationProvider class="form-item" tag="div" name="username" rules="username" v-slot="{ errors }">
          <div class="input-field">
            <span class="form-icon username"></span>
            <input class="form-input" type="text" v-model="params.username" />
          </div>
          <div class="errorMsg">{{ errors[0] }}</div>
        </ValidationProvider>
        <ValidationProvider class="form-item" tag="div" name="password" rules="password" v-slot="{ errors }">
          <div class="input-field">
            <span class="form-icon password"></span>
            <input class="form-input" type="password" v-model="params.password" />
          </div>
          <div class="errorMsg">{{ errors[0] }}</div>
        </ValidationProvider>
        <div class="submit-login">
          <button class="btn-submit login" type="submit">
            <img class="icon-bonus" src="../assets/image/bonus.png" alt="" />
          </button>
        </div>
      </form>
    </ValidationObserver>
  </div>
</template>

<script>
import Api from "../api/api";
export default {
  data() {
    return {
      params: {
        username: "",
        password: "",
      },
    };
  },
  computed: {
    domainUrl() {
      return this.$store.state.domain;
    },
  },
  methods: {
    async onSubmit() {
      const isValid = await this.$refs.form.validate();
      if (isValid) {
        this.loginMethod();
      }
    },
    loginMethod() {
      this.$loading.show();
      Api.login(this.params)
        .then((res) => {
          const { token } = res.value;
          location.href = `${this.domainUrl}?token=${token}`;
        })
        .finally(() => this.$loading.hide());
    },
  },
};
</script>

<style lang="scss">
.login {
  width: 100%;
  .login-form {
    width: 100%;
  }
  .form {
    width: 100%;
  }
  .submit-login {
    width: 100%;
    position: absolute;
    left: 50%;
    bottom: -20px;
    padding: 0 43px;
    transform: translateX(-50%);
  }
  .btn-submit.login {
    position: relative;
    background: url("../assets/image/btn-login.png") no-repeat;
    background-size: 100% 100%;
    .icon-bonus {
      width: 180px;
      position: absolute;
      left: -35px;
      bottom: -38px;
    }
  }
}
</style>
